// [PURPOSE]: Pure helper for the ruleEdition master preset.
// [WHY]: Extracted so both SettingsPanel (onChange) and the unit test can import
//   the same production logic (Rule 22 — no inline test replicas).
// [BREADCRUMB]: Global edition sub-axis (2014/2024). The endgame-correct location
//   is per-character `character.basics.ruleSystem` (RSE-MVP Stage 5); this global
//   preset is a convenience that RSE will reconcile.
//   See master-queue 2M-edition-rse-reconcile.

/**
 * Returns the settings fields that change when the user picks a rule edition.
 * Only the two keys with a clear 2014/2024 difference are flipped here.
 * bastionUnlockLevel and maxInspiration are left alone (no clear edition split).
 *
 * @param {'5e-2014'|'5e-2024'} edition
 * @returns {{ exhaustionRules: string, enableBastionUpgrades: boolean }}
 */
export function applyRuleEditionPreset(edition) {
  if (edition === '5e-2024') {
    return {
      exhaustionRules: '5.5e',
      enableBastionUpgrades: true,
    };
  }
  // Default / '5e-2014'
  return {
    exhaustionRules: '5e',
    enableBastionUpgrades: false,
  };
}
